<template>
  <div>
    <v-row no-gutters>
      <v-col cols="2" sm="2" class="text-center">
        <v-row no-gutters class="pa-1">
          <v-col cols="12" sm="12" class="my-1" v-show="canUpload && !$attrs.disabled">
            <v-btn class="hidden-xs-only" rounded small color="primary" @click="upup">upload</v-btn>
            <v-btn class="hidden-sm-and-up mx-2" fab dark x-small color="primary" @click="upup"><v-icon dark>mdi-upload-outline</v-icon></v-btn>
          </v-col>
          <v-col cols="12" sm="12" v-show="canUpload && !$attrs.disabled">
            <v-btn class="hidden-xs-only" rounded small color="primary" @click="getFiles">reload</v-btn>
            <v-btn class="hidden-sm-and-up mx-2" fab dark x-small color="primary" @click="getFiles"><v-icon dark>loop</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col :cols="canUpload && !$attrs.disabled ? 10 : 12" :sm="canUpload && !$attrs.disabled ? 10 : 12">
        <!-- v-bind:preview-template="template" -->
        <span v-show="!(canUpload && !$attrs.disabled)">
          <v-chip class="mr-1 mt-1" close color="primary" text-color="white" close-icon="loop" @click="getFiles">รายการไฟล์แนบ</v-chip>
        </span>
        <dropzone
          style="width: 100%"
          id="customdropzone"
          v-show="canUpload && !$attrs.disabled"
          ref="myVueDropzone"
          @vdropzone-success="showSuccess"
          @vdropzone-success-multiple="successMulti"
          @vdropzone-sending="sending"
          @vdropzone-error="vdropzone_error"
          @vdropzone-mounted="setUrl()"
          :options="dropzoneOptions"
          :include-styling="true"
        >
        </dropzone>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col v-for="(item, index) in files" :key="item.id" class="text-center" cols="12" sm="6" md="6" lg="4" xl="3">
        <v-chip v-if="item.Type !== 'File folder'" class="mr-1 mt-1" color="green" text-color="white">
          <v-avatar left class="green darken-4" @click="deleteFile(item)" v-if="!$attrs.disabled && canDelete">
            <v-icon>mdi-delete</v-icon>
          </v-avatar>
          <div :id="'div_file' + (index + 1)" @click="openLink(item.Link)">{{ item.Name }}</div>
        </v-chip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@/services/Api'
import Dropzone from 'vue2-dropzone'

// import bus from '@/components/bus'
export default {
  name: 'drop_zone',
  // props: ['code', 'list', 'dzName', 'maxSize', 'appName', 'canDelete'],
  props: {
    appName: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    list: {
      default: ''
    },
    dzName: {
      type: String,
      default: 'dz'
    },
    maxSize: {
      type: Number,
      default: 2
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canUpload: {
      type: Boolean,
      default: true
    },
    nameCode: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: 'image/*,application/pdf,.docx,.xlsx,.pptx'
    }
  },
  data() {
    return {
      // uploadURL: 'https://httpbin.org/post',
      serverName: process.env.VUE_APP_SERVER_NAME,
      API_PATH: process.env.VUE_APP_API_PATH,
      uploadURL: process.env.VUE_APP_API_PATH + 'api/Upload3/UploadMember.asp',
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'File',
      queryString: '',
      temp: [],
      files: [],
      dropzoneOptions: {
        url: process.env.VUE_APP_API_PATH,
        acceptedFiles: this.fileType,
        maxFileSizeInMB: this.maxSize * 1000,
        autoProcessQueue: true,
        paramName: 'file',
        addRemoveLinks: true
      }
    }
  },
  components: {
    Dropzone
  },
  mounted() {
    // this.files = this.fileList
    this.getFiles()
  },
  watch: {
    files: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.$emit('filesChange', val)
        })
      }
    },
    code: function (val) {
      if (val !== '') {
        this.$nextTick(() => {
          this.setUrl()
          this.getFiles()
        })
      }
    },
    list: function (val) {
      if (val !== '') {
        this.$nextTick(() => {
          this.getFiles()
        })
      }
    }
  },
  computed: {
    computeURL() {
      var tempUrl = ''
      if (this.code) {
        tempUrl = this.uploadURL + '?dropzone=1' + '&id=' + this.code
        if (this.list !== undefined) {
          tempUrl = this.uploadURL + '?dropzone=1' + '&id=' + this.code + '&list=' + this.list
        }
      } else {
        tempUrl = this.uploadURL + '?dropzone=1'
      }
      if (this.appName !== undefined) {
        tempUrl += '&app=' + this.appName
      }
      if (this.maxSize !== undefined) {
        tempUrl += '&m=' + this.maxSize
      }
      if (this.nameCode !== undefined) {
        tempUrl += '&nameCode=' + this.nameCode
      }
      // console.log('tempUrl', tempUrl)
      return tempUrl
    }
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
    setUrl() {
      console.log('setURL')
      // this.dropzoneOptions.url = this.computeURL
      this.$refs.myVueDropzone.setOption('url', this.computeURL)
      this.getFiles()
    },
    sending(file, xhr, formData) {
      // console.log('url', this.$refs.myVueDropzone.url)
      // console.log('sending file', file.name)
      // console.log('sending xhr', xhr.responseURL)
      var fn = encodeURI(file.name)
      // formData.append('encFilename', fn)
      formData.append('filename', fn)
    },
    upup() {
      this.$refs.myVueDropzone.options.url = this.computeURL
      this.$refs.myVueDropzone.dropzone.options.url = this.computeURL
      this.dropzoneOptions.url = this.computeURL
      this.$refs.myVueDropzone.processQueue()
      this.temp = this.$refs.myVueDropzone.getUploadingFiles()
      if (this.temp.length > 0) {
        this.temp = this.temp[0].xhr
      }
    },
    previewTemplate() {
      return `
                <div class="dz-preview dz-file-preview">
                  <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div class="dz-size" data-dz-size></div>
                    <img data-dz-thumbnail />
                  </div>
                  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                  <div class="dz-success-mark"><span>✔</span></div>
                  <div class="dz-error-mark"><span>✘</span></div>
                  <div class="dz-error-message"><span data-dz-errormessage></span></div>
                </div>
              `
    },
    successMulti(files, response) {
    },
    vdropzone_error(file) {
      console.log('error', file)
    },
    showSuccess(file) {
      console.log('error', file)
      this.files = this.files.filter(function (ele) {
        return ele.Name !== JSON.parse(file.xhr.responseText)[0].Name
      })
      this.files.push(JSON.parse(file.xhr.responseText)[0])

      this.$refs.myVueDropzone.removeFile(file)
      // console.log('A file was successfully uploaded')
      this.$emit('uploadSuccess', file)
    },
    hasFiles() {
      return this.files.length > 0
    },
    getFiles() {
      this.files = []
      var param = {}
      param.appName = this.appName
      param.ID = this.code
      param.nameCode = this.nameCode
      param.List = this.list
      Api.httpServer()
        .post(this.API_PATH + 'taimember/default.asp?controller=pfile&action=getfile', param)
        .then((response) => {
          var dataItem = response.data.data
          if (dataItem.length > 0) {
            this.files = dataItem
          } else {
            this.files = []
          }
        })
    },
    deleteFile(file) {
      if (!confirm('ต้องการลบไฟล์นี้ใช่หรือไม่ ?')) return

      Api.httpServer()
        .post(this.API_PATH + 'taimember/default.asp?controller=pfile&action=deletefile', file)
        .then((response) => {
          console.log('delete response:', response.data)

          // เอาไฟล์ออกจาก UI
          this.files = this.files.filter(ele => ele.Name !== file.Name)

          // โหลดไฟล์ใหม่อีกครั้งเพื่ออัปเดตรายการจริง
          this.getFiles()
        })
        .catch((err) => {
          console.error('Error deleting file:', err)
        })
    }
      }
    }
</script>
<style scoped>
</style>
